/* eslint-disable */
// @ts-nocheck
import type { Filter } from '../../../../../main/types/druidTypes';
export type AndType = 'and';
export default class AndFilter {
  type: AndType;

  fields: Filter[];

  field: void;

  dimension: void;

  values: void;

  pattern: void;

  constructor(fields: Filter[]) {
    this.type = 'and';
    this.fields = fields ? fields : [];
  }
}
